import {
  Row,
  Col,
  Card,
  Table,
  DatePicker,
  Button,
  Typography,
  Empty,
  Space,
} from "antd";
import axios from "axios";
import React, { useState, useContext } from "react";
import { userContext } from "../context/UserContext";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import Loader from "../components/loader";
import { CSVLink } from "react-csv";

const ClientReport = () => {
  const { Title } = Typography;
  const { person } = useContext(userContext);
  const history = useHistory();

  const [dateRange, setDateRange] = useState(null);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);

  const formatdate = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const formattedDate = `${day.toString().padStart(2, "0")}-${month
      .toString()
      .padStart(2, "0")}-${year}`;
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    return `${formattedDate} ${formattedTime}`;
  };

  const columns = [
    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      render: (type, record) => (
        <div className="avatar-info">
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <Title level={5}>{type}</Title>
              <h6>{formatdate(record.date_created)}</h6>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => (
        <div className="author-info">
          <h6>K{parseFloat(amount).toFixed(2)}</h6>
        </div>
      ),
    },
    {
      title: "TRANSACTION",
      key: "transtype",
      dataIndex: "transtype",
      render: (transtype) => (
        <div className="author-info">
          <h6>{transtype}</h6>
        </div>
      ),
    },
    {
      title: "RECIPIENT",
      dataIndex: "recipient",
      key: "recipient",
      render: (recipient) => (
        <div className="author-info">
          <h6>{recipient}</h6>
        </div>
      ),
    },
    {
      title: "NUMBER",
      key: "phone",
      dataIndex: "phone",
      render: (phone) => (
        <div className="author-info">
          <h6>{phone}</h6>
        </div>
      ),
    },
    {
      title: "STATUS",
      key: "status",
      dataIndex: "status",
      render: (status) => (
        <div className="author-info">
          <h6>{status}</h6>
        </div>
      ),
    },
    {
      title: "ACCOUNT",
      key: "account",
      dataIndex: "account",
      render: (account) => (
        <div className="author-info">
          <h6>{account}</h6>
        </div>
      ),
    },
  ];

  const handleFetch = async () => {
    if (!dateRange || dateRange.length !== 2) {
      return;
    }
    const [start, end] = dateRange;
    const startISO = start.startOf("day").toISOString();
    const endISO = end.endOf("day").toISOString();

    const url = `https://cms.paysmart.co.zm/items/transactions?fields=*,user_created.companyname&sort=-date_created&limit=-1&filter[user_created][companyname][_eq]=${encodeURIComponent(
      person.companyname,
    )}&filter[date_created][_between]=${encodeURIComponent(
      startISO,
    )},${encodeURIComponent(endISO)}`;

    try {
      setLoading(true);
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      });
      setItems(response.data.data || []);
      setHasFetched(true);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        history.push("/sign-in");
      }
    } finally {
      setLoading(false);
    }
  };

  const disabled = !dateRange || dateRange.length !== 2;

  return (
    <div className="tabled">
      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Report"
          >
            <Space wrap>
              <DatePicker.RangePicker
                placeholder={["Start Date", "End Date"]}
                onChange={(dates) => setDateRange(dates)}
                allowClear
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleFetch}
                loading={loading}
                disabled={disabled}
              >
                Load transactions
              </Button>
            </Space>
          </Card>
        </Col>

        {loading && (
          <Col xs={24}>
            <Loader loading={loading} />
          </Col>
        )}

        {!loading && hasFetched && (
          <Col xs={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`Transactions (${items.length})`}
              extra={
                items.length > 0 ? (
                  <CSVLink
                    data={items}
                    filename={"report.csv"}
                    className="ant-btn"
                  >
                    <DownloadOutlined style={{ fontSize: "20px" }} />
                  </CSVLink>
                ) : null
              }
            >
              <div className="table-responsive">
                {items.length === 0 ? (
                  <Empty description="No transactions in this date range" />
                ) : (
                  <Table
                    columns={columns}
                    dataSource={items}
                    rowKey="id"
                    className="ant-border-space"
                    pagination={{ pageSize: 10 }}
                  />
                )}
              </div>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ClientReport;
